/**
 * Map of OneTrustActiveGroups and their IDs
 */
export var CONSENT;
(function (CONSENT) {
    CONSENT["PERFORMANCE"] = "C0063";
    CONSENT["FUNCTIONAL"] = "C0001";
    CONSENT["TARGETING"] = "C0004";
    /**
     * Consent will be handled entirely by GTM
     */
    CONSENT["DEFER"] = "";
})(CONSENT || (CONSENT = {}));
